import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconList = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#9F9F9F",
		d: "M2 8.666h1.333V7.333H2v1.333zm0 2.667h1.333V10H2v1.333zM2 6h1.333V4.667H2V6zm2.667 2.666H14V7.333H4.667v1.333zm0 2.667H14V10H4.667v1.333zm0-6.667V6H14V4.667H4.667z"
	})
});
export default SvgIconList;
